import React from "react";

const Label = ({ children, disabled }) => {
  return (
    <label className={disabled? "block text-sm text-gray-200" : "block text-sm text-black-500"}>
      {children}
    </label>
  );
};

export default Label;
